import * as MutationsType from "./mutationsType";

export default {
  [MutationsType.SHOW_WELCOME_MODAL](state, payload) {
    state.showWelcomeModal = payload;
  },
  [MutationsType.SHOW_TUTORIAL_MODAL](state, payload) {
    state.showTutorialModal = payload;
  },
  [MutationsType.SET_TUTORIAL](state, payload) {
    state.tutorial = payload;
  },
  [MutationsType.SHOW_STEPS_BANNER](state, payload) {
    state.showStepsBanner = payload;
  },
  [MutationsType.SHOW_FREQUENT_QUESTIONS_DRAWER](state, payload) {
    state.showFrequentQuestionsDrawer = payload;
  },
};
